import React, { useState, useEffect, useMemo } from "react";
import { BrowserRouter as Router, useLocation, Route, Link, Switch } from "react-router-dom";
import { ConfigProvider, message } from "antd";
import zhCN from "antd/es/locale/zh_CN";
import "antd/dist/antd.css";
import Index from "./index";
import Login from "./login/login";
import Register from "./register";
import Forget from "./forget";
import Privacy from "./privacy";
import ServiceAgreement from "./service-agreement";
import Animation from "../components/animation";
import EmailAudit from "./email-audit";
import SelectRole from "./select-role";
import TallyDetail from "./extra-page/tally-detail";

import "./app.less";
import { lib, PersonalCenter, DownloadCenter, hooks } from "react-single-app";
import Header from "../components/header";
import useRootPath from "../components/hook/useRootPath";
import WxLogin from "./oauth/wx-login";
import { PLATFORM_CODE } from "./oauth/types";
import OauthMiddlePage from "./oauth/oauth-middle-page";
import useUserAgent from "../components/hook/useUserAgent";
// import { lib, event,hooks } from 'react-single-app'

const Copyright = props => {
    const host = window.location.host;
    return (
        <div className="copyright">
            <div>
                <a
                    href={props.copyrightLink || "https://beian.miit.gov.cn/#/Integrated/index"}
                    target="blank">
                    {props.copyright ||
                        `Copyright ©2017-现在浙ICP备17034299号-${
                            host.includes("dataeta.com") ? "2" : "1"
                        }`}
                </a>
            </div>
            <div>
                <a
                    className="copyright-link"
                    target="_blank"
                    href={
                        props.leftPageFooterLink ||
                        "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010202002104"
                    }>
                    <img src="https://dante-img.oss-cn-hangzhou.aliyuncs.com/94159368327.png" />
                    <span style={{ display: "inline-block", marginRight: "8px" }}>
                        {props.leftPageFooter || "浙公网安备 33010202002104号"}
                    </span>
                </a>
                <a
                    href={
                        props.rightPageFooterLink ||
                        "https://dante-img.oss-cn-hangzhou.aliyuncs.com/94244442758.jpeg"
                    }
                    target="blank">
                    {props.rightPageFooter || "增值业务电信经营许可证 浙B2-20180827"}
                </a>
            </div>
        </div>
    );
};
message.config({
    duration: 5,
});
function App() {
    let location = useLocation("");
    useUserAgent();
    let rootPath = useRootPath();
    let locationPath = location.pathname.replace(rootPath, "").replace("/", "");
    const [saasInfo, loading] = hooks.useSaasInfo();
    useEffect(() => {
        document.title = saasInfo?.systemName;
    }, [saasInfo]);

    console.log(locationPath);

    return (
        <div className={`account ${locationPath}`}>
            <ConfigProvider locale={zhCN}>
                {lib.config.webToken == "admin" && <Animation />}
                {rootPath && (
                    <Switch>
                        <Route path={`${rootPath}/login`}>
                            <Login saasInfo={saasInfo} loading={loading} />
                        </Route>

                        <Route path={`${rootPath}/register`}>
                            <Register />
                        </Route>
                        <Route path={`${rootPath}/forget`}>
                            <Forget />
                        </Route>
                        <Route path={`${rootPath}/privacy`}>
                            <Privacy />
                        </Route>
                        <Route path={`${rootPath}/service-agreement`}>
                            <ServiceAgreement />
                        </Route>
                        <Route path={`${rootPath}/personal-center`}>
                            <div className="index-contain">
                                <Header />
                                <PersonalCenter />
                            </div>
                        </Route>
                        <Route path={`${rootPath}/download-center`}>
                            <div className="index-contain">
                                <Header />
                                <DownloadCenter />
                            </div>
                        </Route>
                        <Route path={`${rootPath}/email-audit`}>
                            <EmailAudit />
                        </Route>
                        <Route path={`${rootPath}/tally-detail`}>
                            <TallyDetail />
                        </Route>
                        <Route path={"/select-role"}>
                            <SelectRole saasInfo={saasInfo} loading={loading} />
                        </Route>
                        <Route path={`${rootPath}/wxLogin`}>
                            <WxLogin platformCode={PLATFORM_CODE.Wx} />
                        </Route>
                        <Route path={`${rootPath}/qy-wx-login`}>
                            <WxLogin platformCode={PLATFORM_CODE.QyWx} />
                        </Route>
                        <Route path={`/oauth-middle-page`}>
                            <OauthMiddlePage saasInfo={saasInfo} loading={loading} />
                        </Route>
                        <Route path={`${rootPath}`}>
                            <Index />
                        </Route>
                    </Switch>
                )}

                {["email-audit", "tally-detail"].includes(locationPath) !== true && (
                    <Copyright
                        leftPageFooter={saasInfo.leftPageFooter}
                        leftPageFooterLink={saasInfo.leftPageFooterLink}
                        rightPageFooter={saasInfo.rightPageFooter}
                        rightPageFooterLink={saasInfo.rightPageFooterLink}
                        copyright={saasInfo.copyright}
                        copyrightLink={saasInfo.copyrightLink}
                    />
                )}
            </ConfigProvider>
        </div>
    );
}

export default App;
